var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Site } from '@debbie/common/dist';
import { availableScopeGroups, availableScopes } from '@debbie/common/dist/keys';
import { c } from '@debbie/cortex/dist';
import * as keysLib from '@debbie/cortex/dist/api/keys';
import { selectedCreditorId } from '@debbie/cortex/dist/internal';
import { selectKeys } from '@debbie/cortex/dist/keys/selectors';
import { selectRole } from '@debbie/cortex/dist/me/selectors';
import { selectTenantId } from '@debbie/cortex/dist/selectedOwners/selectors';
import THEME from '../theme';
import X from './Icons/X';
import UserType from './UserType';
import { PlaceholderLoader, Button, Checkbox, Input, Table, Modal, Well, CopyToClipboard, } from '.';
import { Size } from '../design-system';
import styled from 'styled-components';
import UserPreview from './performed-by/UserPreview';
const APIKeys = (props) => {
    const lang = useSelector((s) => s.lang);
    const keys = useSelector(selectKeys);
    const meRole = useSelector(selectRole);
    const tenantId = useSelector(selectTenantId);
    const site = useSelector((s) => s.site);
    useEffect(() => {
        if (!keys) {
            c.keys.get();
        }
    }, []);
    const [modalOpen, setModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingDeletion, setLoadingDeletion] = useState(false);
    const [name, setName] = useState('');
    const [scopes, setScopes] = useState([]);
    const [newKey, setNewKey] = useState('');
    return (React.createElement("div", null,
        React.createElement("p", null,
            "API Documentation:",
            ' ',
            React.createElement("a", { target: "blank", href: site === Site.Client
                    ? 'https://creditor-docs.debbie.dk/'
                    : 'https://platform-docs.debbie.dk/' }, "Documentation")),
        tenantId && (React.createElement("p", null,
            "tenantId:",
            ' ',
            React.createElement("b", null,
                React.createElement(CopyToClipboard, null, tenantId)))),
        selectedCreditorId && Site.Client === site && (React.createElement("p", null,
            "creditorId:",
            ' ',
            React.createElement("b", null,
                React.createElement(CopyToClipboard, null, selectedCreditorId)))),
        React.createElement("h3", null, lang.apiSettings.keys),
        keys ? (keys.length === 0 ? (React.createElement("h3", { style: {
                textAlign: 'center',
                opacity: 0.7,
            } }, lang.apiSettings.noKeysYet)) : (React.createElement(Table, { zebra: true }, keys.map((key) => {
            return (React.createElement("tr", null,
                React.createElement("td", null, key.createdByUserId && (React.createElement(UserPreview, { id: key.createdByUserId }))),
                React.createElement("td", null,
                    React.createElement("b", null,
                        React.createElement(CopyToClipboard, { hideIcon: true, text: key.id }, key.name))),
                React.createElement("td", null,
                    React.createElement(UserType, { role: key.role }, lang.roles[key.role])),
                React.createElement("td", null, key.scopes.join()),
                React.createElement("td", { style: { textAlign: 'right' } }, moment(key.createdAt).format(THEME.DATE_FORMAT_LONG)),
                React.createElement("td", { style: { textAlign: 'right' } }, loadingDeletion ? (React.createElement(PlaceholderLoader, { width: "40px" })) : (React.createElement(X, { onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        setLoadingDeletion(true);
                        try {
                            yield keysLib.del(key.id, selectedCreditorId);
                            c.keys.get();
                        }
                        catch (error) {
                            console.error(error);
                            alert('error');
                        }
                        setLoadingDeletion(false);
                    }), style: { cursor: 'pointer' } })))));
        })))) : (React.createElement(PlaceholderLoader, null)),
        React.createElement("br", null),
        React.createElement(Button, { onClick: () => setModalOpen(!modalOpen) }, lang.apiSettings.newKeyButton),
        modalOpen && (React.createElement(Modal, { maxWidth: "600px", onToggle: () => setModalOpen(!modalOpen), header: lang.apiSettings.newKey }, newKey ? (React.createElement("div", null,
            React.createElement("p", null, lang.apiSettings.newKeyCreatedInfo),
            React.createElement(Well, null,
                React.createElement("b", null,
                    React.createElement(CopyToClipboard, { text: newKey }, newKey))),
            React.createElement("br", null),
            React.createElement(Button, { onClick: () => {
                    setNewKey('');
                    setModalOpen(false);
                } }, lang.apiSettings.closeModal))) : (React.createElement("div", null,
            React.createElement(Input, { placeholder: lang.apiSettings.keyName, value: name, onChange: (e) => {
                    setName(e.target.value);
                } }),
            React.createElement("b", null,
                React.createElement(Checkbox, { placeholder: 'Select all', checked: scopes.length > 0, checkMark: true, size: Size.Small, onChange: (e) => {
                        const checked = e.target.checked;
                        if (checked) {
                            if (meRole) {
                                setScopes(availableScopes[meRole]);
                            }
                        }
                        else {
                            setScopes([]);
                        }
                    } })),
            React.createElement("br", null),
            React.createElement("br", null),
            meRole &&
                availableScopeGroups[meRole].map((group) => (React.createElement(ScopeGroup, null, group.scopes.map((scope) => (React.createElement(ScopeCheckbox, { key: scope, onChange: (scopes) => setScopes(scopes), scope: scope, scopes: scopes })))))),
            React.createElement("br", null),
            React.createElement(Button, { block: true, disabled: !(name && name.length > 2 && scopes.length > 0), loading: loading, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                    try {
                        setLoading(true);
                        const res = yield keysLib.create({
                            name,
                            scopes,
                        }, selectedCreditorId);
                        c.keys.get();
                        setNewKey(res.key);
                        setName('');
                        setScopes([]);
                    }
                    catch (error) {
                        console.error(error);
                        alert(error);
                    }
                    setLoading(false);
                }) }, lang.apiSettings.createNewKey)))))));
};
export default APIKeys;
const ScopeCheckbox = (props) => {
    return (React.createElement("div", null,
        React.createElement(Checkbox, { placeholder: props.scope, checked: !!props.scopes.find((e) => e === props.scope), checkMark: true, size: Size.Small, onChange: (e) => {
                const checked = e.target.checked;
                props.onChange(checked
                    ? props.scopes.concat(props.scope)
                    : props.scopes.filter((_e) => _e !== props.scope));
            } })));
};
const ScopeGroup = styled.div `
  margin-bottom: ${THEME.GRID_SPACING}px;
`;
//# sourceMappingURL=APIKeys.js.map